import { Analysis, PossibleRootCauseCategory } from '.';

export class NutrientsAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.calcium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8000);
        } else if (this.ba.calcium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8010);
        }

        if (this.ba.ceruloplasmin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8020);
        } else if (this.ba.ceruloplasmin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8030);
        }

        if (this.ba.copperRBCμgdL.isGreaterThanOptimal() || this.ba.copperRBCμgmL.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8040);
        } else if (this.ba.copperRBCμgdL.isStricklyLessThanOptimal() || this.ba.copperRBCμgmL.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8050);
        } 

        if (this.ba.copperSerummcgmL.isGreaterThanOptimal() || this.ba.copperSerumμgdL.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8060);
        }

        if (this.ba.copperSerummcgmL.isGreaterThanOptimal() || this.ba.copperSerumμgdL.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8060);
        } else if (this.ba.copperSerummcgmL.isStricklyLessThanOptimal() || this.ba.copperSerumμgdL.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8070);
        }

        if (this.ba.copperZincRatio.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8072);
        } else if (this.ba.copperZincRatio.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8074);
        }

        if (this.ba.percentOfFreeCopper.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8076);
        } else if (this.ba.percentOfFreeCopper.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8078);
        }

        if (this.ba.folateRBC.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8080);
        } else if (this.ba.folateRBC.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8090);
        }

        if (this.ba.folateSerum.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8100);
        } else if (this.ba.folateSerum.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8110);
        }

        if (this.ba.magnesiumRBC.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8120);
        } else if (this.ba.magnesiumRBC.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8130);
        }

        if (this.ba.magnesium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8140);
        } else if (this.ba.magnesium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8150);
        }

        if (this.ba.phosphorus.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8160);
        } else if (this.ba.phosphorus.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8170);
        }

        if (this.ba.vitaminA.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8180);
        } else if (this.ba.vitaminA.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8190);
        }

        if (this.ba.vitaminB6.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8200);
        } else if (this.ba.vitaminB6.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8210);
        }

        if (this.ba.vitaminB12.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8220);
        } else if (this.ba.vitaminB12.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8230);
        }

        if (this.ba.vitaminD.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8240);
        } else if (this.ba.vitaminD.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8250);
        }

        if (this.ba.vitaminD125.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8260);
        } else if (this.ba.vitaminD125.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8270);
        }

        if (this.ba.zincRBCmgL.isGreaterThanOptimal() || this.ba.zincRBCμgdL.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8280);
        } else if (this.ba.zincRBCmgL.isStricklyLessThanOptimal() || this.ba.zincRBCμgdL.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8290);
        }

        if (this.ba.zincSerummcgmL.isGreaterThanOptimal() || this.ba.zincSerumμgdL.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8300);
        } else if (this.ba.zincSerummcgmL.isStricklyLessThanOptimal() || this.ba.zincSerumμgdL.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_8310);
        }
    }
}